import { createContext, ReactNode, useContext, useState } from "react";

export interface IChatbotMessageContext {
    messageCount: number;
    updateMessageCount: (count: number) => void;
    onMessageCountChange?: (count: number) => void;
    setOnMessageCountChange: (callback?: (count: number) => void) => void;
}

export const ChatbotMessageContext = createContext<IChatbotMessageContext | undefined>(undefined);

export interface IChatbotMessageProviderProps {
    children: ReactNode;
}

export const ChatbotMessageProvider: React.FC<IChatbotMessageProviderProps> = ({ children }) => {
    const [messageCount, setMessageCount] = useState<number>(0);
    const [onMessageCountChange, setOnMessageCountChangeState] = useState<((count: number) => void) | undefined>();

    const updateMessageCount = (count: number) => {
        setMessageCount(count);
        if (onMessageCountChange) {
            onMessageCountChange(count);
        }
    };

    const setOnMessageCountChange = (callback?: (count: number) => void) => {
        setOnMessageCountChangeState(() => callback);
    };

    const contextValue: IChatbotMessageContext = {
        messageCount,
        updateMessageCount,
        onMessageCountChange,
        setOnMessageCountChange
    };

    return (
        <ChatbotMessageContext.Provider value={contextValue}>
            {children}
        </ChatbotMessageContext.Provider>
    );
};

export const useChatbotMessageContext = (): IChatbotMessageContext => {
    const context = useContext(ChatbotMessageContext);
    if (context === undefined) {
        throw new Error('useChatbotMessageContext must be used within a ChatbotMessageProvider');
    }
    return context;
};
